/* First-load page entrance, played by CSS from first paint (see
   PageTransition.tsx). Same motion as the framer-motion variants used for
   client-side navigation. `backwards` (not `both`): once it ends, the inline
   styles framer-motion owns take over again, so the exit animation still
   works when the visitor navigates away. */

.pageEnterFade {
  animation: pageEnterFade 0.5s cubic-bezier(0.16, 1, 0.3, 1) backwards;
}

.pageEnterLeft {
  animation: pageEnterLeft 0.65s cubic-bezier(0.16, 1, 0.3, 1) backwards;
}

.pageEnterRight {
  animation: pageEnterRight 0.65s cubic-bezier(0.16, 1, 0.3, 1) backwards;
}

.pageEnterBottom {
  animation: pageEnterBottom 0.65s cubic-bezier(0.16, 1, 0.3, 1) backwards;
}

@keyframes pageEnterFade {
  from {
    opacity: 0;
  }
}

@keyframes pageEnterLeft {
  from {
    opacity: 0;
    transform: translateX(-100%);
  }
}

@keyframes pageEnterRight {
  from {
    opacity: 0;
    transform: translateX(100%);
  }
}

@keyframes pageEnterBottom {
  from {
    opacity: 0;
    transform: translateY(100%);
  }
}
